export default __webpack_public_path__ + "static/media/navigateto.b331972e.svg";